// 用户端活动模块路由。
// 活动列表/详情无需登录；我的订单和签到页需要登录态。
const children = [
  {
    path: 'list',
    name: 'activity_list',
    meta: { title: '活动列表', requiresAuth: false },
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/list.vue')
  },
  {
    path: 'detail/:id',
    name: 'activity_detail',
    meta: { title: '活动详情', requiresAuth: false },
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/detail.vue')
  },
  {
    path: 'my-orders',
    name: 'activity_my_orders',
    meta: { title: '我的活动订单', requiresAuth: true },
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/my_orders.vue')
  },
  {
    path: 'checkin',
    name: 'activity_checkin',
    meta: { title: '活动签到', requiresAuth: true },
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/checkin.vue')
  }
];

export default {
  path: '/activity',
  name: 'activity',
  meta: { title: '活动中心' },
  component: () => import('@/layout/user.vue'),
  children
};
